import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'seduo-ui';
const Example = (props) => (<div>
        <Breadcrumb tag="nav">
            <BreadcrumbItem tag="a" href="#">
                Home
            </BreadcrumbItem>
            <BreadcrumbItem tag="a" href="#">
                Library
            </BreadcrumbItem>
            <BreadcrumbItem tag="a" href="#">
                Data
            </BreadcrumbItem>
            <BreadcrumbItem active tag="span">
                Bootstrap
            </BreadcrumbItem>
        </Breadcrumb>
    </div>);
export default Example;
